import { abbrNum } from 'utils/helper/common';

import type { BarChartSimpleItem, StatisticsCommon, StatisticsCountry } from 'types';

export const getTopAudienceCountriesBarChartData = (
  data: Array<StatisticsCountry> | undefined | null,
  type: 'standard' | 'percentage',
  roundValue: boolean = true
): Array<BarChartSimpleItem> => (data || []).map(({ country, reach, percent }) => {
  // Standard is used for all creators charts where percentage value is not that helpful
  const isStandardType = type === 'standard';
  const updatedValue = isStandardType ? reach : percent;

  return {
    label: country,
    value: roundValue ? Math.round(updatedValue) : updatedValue,
    additionalMetric: isStandardType ? null : abbrNum(reach)
  };
});

export const getCountriesBarChartData = (
  data: Array<StatisticsCommon> | undefined | null,
  type: 'standard' | 'percentage',
  roundValue: boolean = true
): Array<BarChartSimpleItem> => (data || []).map(({ label, absolute, percentage }) => {
  // Standard is used for all creators charts where percentage value is not that helpful
  const isStandardType = type === 'standard';
  const updatedValue = isStandardType ? absolute : percentage;

  return {
    label,
    value: roundValue ? Math.round(updatedValue) : updatedValue,
    additionalMetric: isStandardType ? null : abbrNum(absolute)
  };
});

export const getCitiesBarChartData = (
  data: Array<StatisticsCommon> | undefined | null,
  type: 'standard' | 'percentage',
  roundValue: boolean = true
): Array<BarChartSimpleItem> => (data || []).map(({ label, absolute, percentage }) => {
  // Standard is used for all creators charts where percentage value is not that helpful
  const isStandardType = type === 'standard';
  const updatedValue = isStandardType ? absolute : percentage;

  return {
    label,
    value: roundValue ? Math.round(updatedValue) : Number(updatedValue.toFixed(2)),
    additionalMetric: isStandardType ? null : abbrNum(absolute)
  };
});
